<template>
  <div
    v-loading="loding"
    class="wrap"
    :element-loading-text="language('login.loginButtonText2')"
  >
    <div>
      <!-- <div class="sys_title" v-if="appTheme.theme">
        {{ appTheme.theme.title }}
      </div> -->
      <!-- <div class="logo" >
      <el-image style="min-width: 120px" :src="logo" fit="cover"></el-image>
      </div> -->
      <el-card class="login-form">
        <div class="logo">
          <el-image
            style="width: 180px; margin: 20px auto 20px auto"
            :src="logo"
            fit="cover"
          ></el-image>
        </div>
        <div class="form_wrap">
          <el-tabs v-model="activeName" stretch @tab-click="handleClick">
            <el-tab-pane
              :label="language('login.tablName1')"
              name="phone"
            ></el-tab-pane>
            <el-tab-pane
              :label="language('login.tablName2')"
              name="email"
            ></el-tab-pane>
          </el-tabs>
          <el-form
            :model="loginForm"
            :rules="rules"
            status-icon
            ref="ruleForm"
            class="form"
          >
            <el-form-item prop="loginName">
              <el-input
                v-model="loginForm.loginName"
                :width="100"
                :placeholder="
                  activeName == 'phone'
                    ? language('login.placeholderLoginName')
                    : language('login.placeholderLoginName2')
                "
                @keyup.enter.native="doLogin"
              >
                <el-select
                  v-model="area"
                  slot="prepend"
                  style="width: 100px"
                  v-if="activeName == 'phone'"
                >
                  <el-option label="+852" value="+852"></el-option>
                  <el-option label="+853" value="+853"></el-option>
                  <el-option label="+86" value="+86"></el-option>
                  <el-option label="+886" value="+886"></el-option>
                </el-select>
              </el-input>
            </el-form-item>
            <el-form-item prop="password">
              <el-input
                type="password"
                v-model="loginForm.password"
                :width="100"
                :placeholder="language('login.placeholderPassword')"
                @keyup.enter.native="doLogin"
              ></el-input>
            </el-form-item>
            <el-form-item prop="captcha">
              <div class="captcha_wrap" v-if="captchaWidth && showCaptcha">
                <Captcha
                  buttonId="login_button"
                  @captchaVerifyCallback="captchaVerifyCallback"
                  :captchaWidth="captchaWidth"
                ></Captcha>
              </div>
            </el-form-item>

            <!-- <el-form-item prop="checkedItem" v-if="showClause">
              <div class="rules_list_wrap">
                <div class="rules_list">
                  <el-checkbox v-model="checkedItem[0].checked"></el-checkbox>
                  <span class="user_check_item"
                    >{{ language("register.rules1[0]")
                    }}{{ appTheme.theme.title
                    }}{{ language("register.rules1[1]")
                    }}<span
                      class="show_cursor"
                      @click="openTermsText(appTheme.theme)"
                      :style="'color:' + appTheme.theme.themeColor"
                      >{{ language("register.termsText") }}</span
                    >{{ language("register.rules1[2]")
                    }}<span
                      class="show_cursor"
                      @click="openPrivacyText(appTheme.theme)"
                      :style="'color:' + appTheme.theme.themeColor"
                      >{{ language("register.privacyText") }}</span
                    >
                  </span>
                </div>
                <div class="rules_list">
                  <el-checkbox v-model="checkedItem[1].checked"></el-checkbox>
                  <span class="user_check_item"
                    >{{ language("register.rules2[0]")
                    }}{{ appTheme.theme.title
                    }}{{ language("register.rules2[1]") }}</span
                  >
                </div>
              </div>
            </el-form-item> -->

            <el-form-item>
              <el-button
                type="primary"
                style="width: 100%"
                @click="doLogin()"
                >{{ language("login.loginButtonText") }}</el-button
              >
            </el-form-item>
          </el-form>

          <div class="forget_text show_cursor" @click="goForgerPW">
            <!-- 忘記密碼 -->
            {{ language("login.forgetText") }}
          </div>
          <div
            class="other_wrap"
            v-if="sdkInfo && (sdkInfo.facebook || sdkInfo.google)"
          >
            <div class="other_title_wrap">
              <div
                :class="
                  locale_lang == 'en'
                    ? 'other_title other_title2'
                    : 'other_title'
                "
              >
                {{ language("login.otherType") }}
              </div>
            </div>
            <div class="other_login_list">
              <div class="other_login_item show_cursor" v-if="sdkInfo.facebook">
                <div class="icon icon-facebook">
                  <img :src="facebook" id="Facebook-signin-button" />
                </div>
              </div>
              <div class="other_login_item show_cursor" v-if="sdkInfo.google">
                <div class="icon icon-google">
                  <img :src="google" id="Google-signin-button" />
                </div>
                <div id="google-name"></div>
              </div>
            </div>
          </div>
          <div class="hollow_button" @click="goRegister">
            <el-button type="primary" plain>{{
              language("login.newUser")
            }}</el-button>
          </div>
        </div>
      </el-card>
    </div>

    <el-dialog
      :title="language('ui.tipsTitle')"
      :visible.sync="showClauseDialog"
      width="650px"
      append-to-body
      :close-on-click-modal="false"
      top="200px"
    >
      <div class="tips_wrap">
        <i class="el-icon-warning icon_tips"></i
        >{{ language("login.tipsText13") }}
      </div>
      <el-form
        :model="loginForm"
        :rules="rules"
        status-icon
        ref="showClauseRuleForm"
      >
        <el-form-item prop="checkedItem">
          <div class="rules_list_wrap">
            <div class="rules_list">
              <el-checkbox v-model="checkedItem[0].checked"></el-checkbox>

              <template v-if="locale_lang == 'zh-HK'">
                <span class="user_check_item"
                  >本人已閱讀及同意「SUPer
                  Card」會員條款、細則及私隱條款，並同意啟動「{{
                    appTheme.theme.title
                  }}」服務接受其<span
                    class="show_cursor"
                    @click="openTermsText(appTheme.theme)"
                    :style="'color:' + appTheme.theme.themeColor"
                    >{{ language("register.termsText") }}</span
                  >及<span
                    class="show_cursor"
                    @click="openPrivacyText(appTheme.theme)"
                    :style="'color:' + appTheme.theme.themeColor"
                    >{{ language("register.privacyText") }}</span
                  >
                </span>
              </template>

              <template v-if="locale_lang == 'en'">
                <span class="user_check_item">
                  I have read and agreed to the Terms & Conditions, Privacy
                  Policy of "SUPer Card." I also agree to activate the service
                  of {{ appTheme.theme.title }} and accept its
                  <span
                    class="show_cursor"
                    @click="openTermsText(appTheme.theme)"
                    :style="'color:' + appTheme.theme.themeColor"
                    >Terms & Conditions</span
                  >
                  and
                  <span
                    class="show_cursor"
                    @click="openPrivacyText(appTheme.theme)"
                    :style="'color:' + appTheme.theme.themeColor"
                    >Privacy Policy</span
                  >.
                </span>
              </template>
            </div>
            <div class="rules_list">
              <el-checkbox v-model="checkedItem[1].checked"></el-checkbox>
              <span class="user_check_item">{{
                languageTC("register.tipsText5", appTheme.theme.title)
              }}</span>
            </div>
          </div>
        </el-form-item>
        <el-form-item>
          <div class="wrap_button">
            <el-button size="small" @click="showClauseDialog = false">{{
              language("form.cancelBtn")
            }}</el-button>
            <el-button type="primary" size="small" @click="openServiceLogin">{{
              language("login.loginButtonText")
            }}</el-button>
          </div>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
const checkPhone = require("../rules/checkPhone.js").mixin;
const checkEmail = require("../rules/checkEmail.js").mixin;
const webWapBindOauthMini = require("../packages/webWapBindOauth").mixin;
import Captcha from "../components/Captcha.vue";

export default {
  mixins: [checkPhone, checkEmail, webWapBindOauthMini],
  components: { Captcha },
  data() {
    return {
      logo: require("@/assets/logo.png"),

      facebook: require("../file/icon/facebook.png"),
      google: require("../file/icon/google.png"),
      loding: false,
      activeName: "phone",
      area: "+852",
      loginForm: {
        loginName: "",
        password: "",
      },
      rules: {
        loginName: [
          {
            required: true,
            message: this.language("login.rulesName"),
            trigger: "blur",
          },
          { validator: this.checkLoginName, trigger: "blur" },
        ],
        password: [
          {
            required: true,
            message: this.language("login.rulesPassword"),
            trigger: "blur",
          },
        ],
        checkedItem: [{ validator: this.checkCheckedItem, trigger: "blur" }],
        captcha: [{ validator: this.checkCaptcha, trigger: "blur" }],
      },
      listServe: [],
      checkedItem: [
        {
          checked: false,
        },
        {
          checked: false,
        },
      ],
      showClauseDialog: false,
      ssoLogin: false,
      loginData: {},

      verifyResult: {
        captchaResult: false,
        bizResult: "",
      },
      showCaptcha: false,
      captchaWidth: 448,
    };
  },
  watch: {
    activeName: {
      handler(o, n) {
        if (o != n && o && n) {
          this.loginForm = {
            loginName: "",
            password: "",
          };
          // this.area = "+852";
          this.$refs["ruleForm"].clearValidate();
        }
      },
      deep: true,
      immediate: true,
    },
    ssoSDK: {
      handler(o, n) {
        if (this.ssoSDK) {
          this.getUser();
        }
      },
      deep: true,
      immediate: true,
    },
    appTheme: {
      handler(o, n) {
        this.listServe = [this.appTheme.theme];
        if (
          this.appTheme.theme &&
          (this.appTheme.theme.facebookAppId ||
            this.appTheme.theme.googleClientId)
        ) {
          let obj = {
            Facebook: {
              appId: this.appTheme.theme.facebookAppId,
              btnId: "Facebook-signin-button",
            },
            Google: {
              client_id: this.appTheme.theme.googleClientId,
              btnId: "Google-signin-button",
            },
          };
          this.initWebWapOauth(obj);
        }
      },
      deep: true,
      immediate: true,
    },
  },
  computed: {
    appTheme: function () {
      return this.$store.state.appData.appTheme;
    },
    ssoSDK: function () {
      return this.$store.state.appData.ssoSDK;
    },
    sdkInfo: function () {
      return this.$store.state.appData.sdkInfo;
    },
  },
  methods: {
    checkCheckedItem(rule, value, callback) {
      if (this.checkedItem[0].checked) {
        callback();
      } else {
        callback(new Error(this.language("register.rulesCheckedItem")));
      }
    },
    checkCaptcha(rule, value, callback) {
      if (this.verifyResult.captchaResult == false && this.showCaptcha) {
        callback(new Error(this.language("login.captchaText")));
      } else {
        callback();
      }
    },
    handleClick(o, n) {},
    checkLoginName(rule, value, callback) {
      let text = "";
      if (this.activeName == "phone") {
        text = this.checkPhone(this.area, this.loginForm.loginName);
      } else {
        text = this.checkEmail(this.loginForm.loginName);
      }
      if (text != "") {
        callback(new Error(text));
      } else {
        callback();
      }
    },
    doLogin() {
      this.$refs["ruleForm"].validate((valid) => {
        if (valid) {
          this.loding = true;
          let loginName = this.loginForm.loginName;
          let password = this.loginForm.password;
          if (this.activeName == "phone") {
            loginName = this.area + this.loginForm.loginName;
            password = this.loginForm.password;
          }

          let data = {
            loginName: loginName,
            password: password,
          };
          if (this.verifyResult.captchaResult == true && this.showCaptcha) {
            data.captcha = this.verifyResult.captcha;
          }

          this.loginData = data;
          oauthSDK
            .login(data)
            .then((res) => {
              this.loding = false;
              this.defalutToast(this.language("login.success"), "success");
            })
            .catch((err) => {
            
              this.loding = false;
              if (err.code == 40003) {
                this.showCaptcha = true;
                this.verifyResult = {
                  captchaResult: false,
                  bizResult: "",
                };
              } else {
                this.openServiceTipsDialog(err)
                  .then(() => {
                    this.showClauseDialog = true;
                  })
                  .catch(() => {});
              }
            });
        } else {
          return false;
        }
      });
    },
    openServiceLogin() {
      this.$refs["showClauseRuleForm"].validate((valid) => {
        if (valid) {
          if (this.ssoLogin) {
            let data = {
              membersession: this.$Cookies.get("memberSessionSSO"),
              forceOpenBs: 1,
            };
            if (this.checkedItem[1].checked) {
              data.agreePushKeys = this.sdkInfo.bsKey;
            }

            oauthSDK
              .ssoLogin(data)
              .then((res) => {
                this.locationPage();
              })
              .catch((err) => {
                this.defalutToast(err.message);
              });
          } else {
            let data = {
              ...this.loginData,
              forceOpenBs: 1,
            };
            if (this.checkedItem[1].checked) {
              data.agreePushKeys = this.sdkInfo.bsKey;
            }
            oauthSDK
              .login(data)
              .then((res) => {
                this.defalutToast(this.language("login.success"), "success");
                this.showClauseDialog = false;
              })
              .catch((err) => {
                this.defalutToast(err.message);
              });
          }
        }
      });
    },
    goForgerPW() {
      this.goToPage({
        url: "forgetPassword",
        query: { type: this.activeName },
      });
    },
    goRegister() {
      this.goToPage({ url: "register", query: {} });
    },
    getUser() {
      oauthSDK
        .getUserInfo()
        .then((theme) => {
          if (!this.$urlData.bsKey) {
            this.locationPage();
            return false;
          }
          oauthSDK
            .ssoLogin({
              membersession: this.$Cookies.get("memberSessionSSO"),
            })
            .then((res) => {
              this.locationPage();
            })
            .catch((err) => {
              this.openServiceTipsDialog(err)
                .then(() => {
                  this.showClauseDialog = true;
                  this.ssoLogin = true;
                  // oauthSDK
                  //   .ssoLogin({
                  //     membersession: this.$Cookies.get("memberSessionSSO"),
                  //     forceOpenBs: 1,
                  //   })
                  //   .then((res) => {
                  //     this.locationPage();
                  //   })
                  //   .catch((err) => {
                  //     this.defalutToast(err.message);
                  //   });
                })
                .catch(() => {});
            });
        })
        .catch((err) => {
          console.log(err);
        });
    },

    locationPage() {
      if (this.$urlData.redirectURL) {
        let url = decodeURIComponent(this.$urlData.redirectURL);
        let session = this.$Cookies.get("memberSessionSSO");
        if (url.indexOf("#") > -1) {
          if (url.indexOf("?") > -1) {
            window.location = url + "&meSe=" + session;
          } else {
            window.location = url + "?meSe=" + session;
          }
        } else {
          window.location = url + "#meSe=" + session;
        }
      }
    },

    openServiceTipsDialog(err) {
      return new Promise((resolve, reject) => {
        if (err.code != 40103) {
          this.defalutToast(err.message);
          reject();
        } else if (err.code == 40103) {
          resolve();
        }
      });
    },
    openTermsText(e) {
      window.open(e.termsUrl);
    },
    openPrivacyText(e) {
      window.open(e.privacyUrl);
    },
    captchaVerifyCallback(e) {
      this.verifyResult = e;
      this.doLogin();
    },
  },
  mounted() {},
  created() {},
};
</script>

<style lang="scss"  scoped>
.wrap {
  height: 100vh;
}
.form_wrap {
  width: 80%;
  margin: 0 auto;
}
.welcome {
  color: lightblue;
  width: 600px;
  text-align: center;
  height: 100px;
  font-size: 80px;
  color: lightgray;
  position: absolute;
  top: 50%;
  left: 50%;
  margin-top: -350px;
  margin-left: -300px;
}
.sys_title {
  width: 600px;
  text-align: center;
  height: 100px;
  font-size: 25px;
  color: gray;
  position: absolute;
  top: 35%;
  left: 50%;
  margin-top: -250px;
  margin-left: -300px;
}
.login-form {
  width: 600px;
  // height: 550px;
  position: absolute;
  // top: 35%;
  top: 28%;
  left: 50%;
  margin-top: -150px;
  margin-left: -300px;
}
.forget_text {
  font-size: 12px;
  color: #666;
  text-align: center;
}
.other_title_wrap {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.other_title {
  margin-top: 30px;
  font-size: 10px;
  color: #666;
  position: relative;
}
.other_title:before {
  content: "";
  display: block;
  position: absolute;
  width: 60px;
  height: 1px;
  // left: 70px;
  left: 82px;
  top: 40%;
  background: #eee;
}
.other_title2:before {
  content: "";
  display: block;
  position: absolute;
  width: 60px;
  height: 1px;
  left: 120px;
  top: 40%;
  background: #eee;
}
.other_title:after {
  content: "";
  display: block;
  position: absolute;
  width: 60px;
  height: 1px;
  left: -70px;
  top: 40%;
  background: #eee;
}
.other_login_list {
  margin-top: 50px;
  display: flex;
  justify-content: space-around;
}
.hollow_button {
  margin-top: 30px;
  button {
    width: 100%;
  }
}
.form {
  margin-top: 20px;
}
.show_cursor {
  cursor: pointer;
}
.tips_wrap {
  display: flex;
  align-items: center;
  font-size: 14px;

  .icon_tips {
    color: #e6a23c;
    font-size: 24px;
    margin-right: 10px;
  }
}
.wrap_button {
  display: flex;
  justify-content: center;
}
.rules_list_wrap {
  // width: 448px;
  margin: 0 auto;

  .user_check_item {
    margin-left: 10px;
    font-size: 12px;
    display: flex;
    span {
      display: inline-block;
    }
  }
  .show_cursor {
    text-decoration: underline;
    padding: 0 4px;
    cursor: pointer;
  }

  .rules_list {
    display: flex;
    align-items: baseline;
    // margin-bottom: 23px;
    margin-top: 14px;
    .user_check_item {
      display: block;
      line-height: 20px !important;
      color: #101010;
    }
  }
}
.logo {
  display: flex;
  align-content: center;
}
</style>